"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabModal = exports.FilterModal = exports.SortModal = void 0;
var outline_1 = require("@heroicons/react/24/outline");
var react_1 = __importStar(require("react"));
var button_1 = require("../../action/button");
var form_1 = require("../../input/form");
var select_1 = require("../../input/select");
var textInput_1 = require("../../input/textInput");
var table_1 = require("../../display/table");
var iconButton_1 = require("../../action/iconButton");
var sortType = [
    {
        key: "asc",
        label: "Ascending",
    },
    {
        key: "desc",
        label: "Descending",
    },
];
var tabTableType = [
    { key: "grid", label: "Grid" },
    { key: "list", label: "List" },
    { key: "iframe", label: "IFrame" },
];
var SortModal = /** @class */ (function (_super) {
    __extends(SortModal, _super);
    function SortModal() {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.apply(this, arguments) || this;
        _this.state = {
            sortId: (_b = (_a = _this.props.sort) === null || _a === void 0 ? void 0 : _a.sortId) !== null && _b !== void 0 ? _b : "",
            sortType: (_d = (_c = _this.props.sort) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : "",
        };
        _this.componentDidUpdate = function (prevProps) {
            var _a, _b;
            if (JSON.stringify(prevProps === null || prevProps === void 0 ? void 0 : prevProps.sort) !== JSON.stringify(_this.props.sort)) {
                _this.setState({
                    sortId: (_a = _this.props.sort) === null || _a === void 0 ? void 0 : _a.sortId,
                    sortType: (_b = _this.props.sort) === null || _b === void 0 ? void 0 : _b.type,
                });
            }
        };
        return _this;
    }
    SortModal.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "pb-28" },
                react_1.default.createElement(select_1.Select, { containerClassName: "mt-5", value: (_a = this.state.sortId) !== null && _a !== void 0 ? _a : "", label: "Sort By", options: (_d = (_c = (_b = this.props).renderReferenceLabelOptions) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : [], onChange: function (value) {
                        _this.setState({ sortId: value });
                    } }),
                react_1.default.createElement(select_1.Select, { containerClassName: "mt-10", value: (_e = this.state.sortType) !== null && _e !== void 0 ? _e : "", label: "Sort Order", options: sortType, onChange: function (value) {
                        _this.setState({ sortType: value });
                    } })),
            react_1.default.createElement("div", { className: "mt-24 flex justify-end" },
                react_1.default.createElement(button_1.Button, { text: "Sort", type: "normal", onClick: function () {
                        if (_this.props.onChangeSort) {
                            _this.props.onChangeSort({
                                sortId: _this.state.sortId,
                                type: _this.state.sortType,
                            });
                        }
                        _this.props.onClose();
                    } }))));
    };
    return SortModal;
}(react_1.Component));
exports.SortModal = SortModal;
var defaultQueryInput = {
    type: "",
    value: "",
    options: [],
};
var FilterModal = /** @class */ (function (_super) {
    __extends(FilterModal, _super);
    function FilterModal() {
        var _this = this;
        var _a;
        _this = _super.apply(this, arguments) || this;
        _this.state = {
            filterQueryModal: false,
            query: defaultQueryInput,
            queries: (_a = _this.props.filter) !== null && _a !== void 0 ? _a : [],
            optionList: [],
        };
        _this.queryFormRef = (0, react_1.createRef)();
        _this.queryTypeRef = (0, react_1.createRef)();
        _this.queryValueRef = (0, react_1.createRef)();
        _this.filterTableHeader = [
            { key: "type", title: "Type" },
            { key: "value", title: "Column" },
            { key: "sort", title: "Sort" },
            { key: "del", title: "Delete" },
        ];
        _this.filterOptionHeader = [
            { key: "name", title: "Name", type: "string" },
            { key: "sort", title: "Sort" },
            { key: "del", title: "Delete" },
        ];
        _this.mongofilterType = [
            {
                key: "reference",
                label: "Reference",
            },
            {
                key: "list",
                label: "List",
            },
            {
                key: "range",
                label: "Range",
            },
        ];
        _this.fbFilterType = [
            { key: "search", label: "Search" },
            {
                key: "reference",
                label: "Reference",
            },
            {
                key: "list",
                label: "List",
            },
        ];
        _this.componentDidUpdate = function (prevProps) {
            if (JSON.stringify(prevProps.filter) !== JSON.stringify(_this.props.filter)) {
                _this.setState({
                    queries: _this.props.filter,
                });
            }
        };
        _this.handleOnChangeQueryInput = function (id, value) {
            var clonedQueryInput = JSON.parse(JSON.stringify(_this.state.query));
            clonedQueryInput[id] = value;
            _this.setState({ query: clonedQueryInput });
        };
        _this.handleFilterQuery = function (index, sortType, isOption) {
            var _a, _b;
            var sortList = JSON.parse(JSON.stringify(isOption ? _this.state.optionList : _this.state.queries));
            var ascIndex = sortType === "up" ? index - 1 : index + 1;
            _a = [
                sortList[ascIndex],
                sortList[index],
            ], sortList[index] = _a[0], sortList[ascIndex] = _a[1];
            _this.setState((_b = {}, _b[isOption ? "optionList" : "queries"] = sortList, _b));
        };
        _this.handleAddFilterData = function (isOption, data) {
            var _a, _b, _c, _d, _e, _f;
            if (isOption) {
                var clonedOptionList = (_a = _this.state.optionList) !== null && _a !== void 0 ? _a : [];
                var optionText = data["name"];
                if (_this.state.optionList && optionText)
                    clonedOptionList.push(optionText);
                _this.setState({ optionList: clonedOptionList });
            }
            else {
                if (((_b = _this.state.query) === null || _b === void 0 ? void 0 : _b.type) === "list" &&
                    ((_c = _this.state.optionList) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                    (_e = (_d = _this.props).setNotification) === null || _e === void 0 ? void 0 : _e.call(_d, {
                        type: false,
                        title: "Slice Error",
                        msg: "Please at least add one option into the list",
                    });
                }
                else {
                    var clonedQueries = (_f = _this.state.queries) !== null && _f !== void 0 ? _f : [];
                    var currentQuery = JSON.parse(JSON.stringify(_this.state.query));
                    currentQuery["options"] = JSON.parse(JSON.stringify(_this.state.optionList));
                    clonedQueries.push(currentQuery);
                    _this.setState({
                        queries: clonedQueries,
                        filterQueryModal: false,
                        optionList: [],
                    });
                }
            }
        };
        _this.handleUpdateNewQueryModal = function (filterQueryModal) {
            _this.setState({ filterQueryModal: filterQueryModal });
        };
        _this.handleSpliceFilter = function (index, isOption) {
            var _a;
            var temp = JSON.parse(JSON.stringify(isOption ? _this.state.optionList : _this.state.queries));
            temp.splice(index, 1);
            _this.setState((_a = {}, _a[isOption ? "optionList" : "queries"] = temp, _a));
        };
        _this.renderFilterData = function (isOption) {
            var filterQueryStructureView = [];
            var sortComponent = undefined;
            var list = isOption ? _this.state.optionList : _this.state.queries;
            list === null || list === void 0 ? void 0 : list.map(function (data, index) {
                if (list && list.length > 1) {
                    var upData_1 = index === list.length - 1;
                    sortComponent = (react_1.default.createElement("div", { className: "ml-2 cursor-pointer", onClick: function () {
                            _this.handleFilterQuery(index, upData_1 ? "up" : "down", isOption);
                        } }, upData_1 ? (react_1.default.createElement(outline_1.ArrowUpIcon, { className: "block w-5 h-5 text-primary-600" })) : (react_1.default.createElement(outline_1.ArrowDownIcon, { className: "block w-5 h-5 text-primary-600" }))));
                }
                var eachData = isOption
                    ? { key: index, name: data }
                    : { key: index, type: data.type, value: data.value };
                filterQueryStructureView.push(__assign(__assign({}, eachData), { sort: sortComponent, del: (react_1.default.createElement("div", { className: "ml-2 cursor-pointer", onClick: function () {
                            _this.handleSpliceFilter(index, isOption);
                        } },
                        react_1.default.createElement(outline_1.TrashIcon, { className: "block w-5 h-5 text-primary-600" }))) }));
                return "";
            });
            return filterQueryStructureView;
        };
        return _this;
    }
    FilterModal.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (this.state.filterQueryModal) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(form_1.Form, { className: "mt-5 pb-32", refList: [this.queryTypeRef, this.queryValueRef], handleComplete: function () {
                        _this.handleAddFilterData();
                    }, ref: this.queryFormRef },
                    react_1.default.createElement(select_1.Select, { ref: this.queryTypeRef, value: (_b = (_a = this.state.query) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : "", label: "Slice Type", options: this.props.server === "mongoServer"
                            ? this.mongofilterType
                            : this.fbFilterType, onChange: function (value) {
                            _this.handleOnChangeQueryInput("type", value);
                        } }),
                    react_1.default.createElement(select_1.Select, { containerClassName: "mt-5", ref: this.queryValueRef, value: (_d = (_c = this.state.query) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : "", label: "Column", options: (_l = (((_e = this.state.query) === null || _e === void 0 ? void 0 : _e.type) === "reference"
                            ? (_g = (_f = this.props).renderReferenceLabelOptions) === null || _g === void 0 ? void 0 : _g.call(_f, "", true, "reference")
                            : (_j = (_h = this.props).renderReferenceLabelOptions) === null || _j === void 0 ? void 0 : _j.call(_h, "", false, ((_k = this.state.query) === null || _k === void 0 ? void 0 : _k.type) === "range" ? "date" : undefined))) !== null && _l !== void 0 ? _l : [], onChange: function (value) {
                            _this.handleOnChangeQueryInput("value", value);
                        } }),
                    ((_m = this.state.query) === null || _m === void 0 ? void 0 : _m.type) === "list" && (react_1.default.createElement(table_1.Table, { className: "py-7", header: this.filterOptionHeader, data: this.renderFilterData(true), loading: false, addable: {
                            active: true,
                            onAddData: function (data) {
                                _this.handleAddFilterData(true, data);
                            },
                        } }))),
                react_1.default.createElement("div", { className: "flex justify-end items-end" },
                    react_1.default.createElement(button_1.Button, { className: "mr-5", text: "Back", type: "light", onClick: function () {
                            _this.handleUpdateNewQueryModal(false);
                        } }),
                    react_1.default.createElement(button_1.Button, { text: "Add", type: "normal", onClick: function () {
                            var _a;
                            (_a = _this.queryFormRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit();
                        } }))));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "flex flex-row mb-2 items-center mt-3" },
                    react_1.default.createElement("h2", { className: "text-2xl font-bold text-gray-700" }, "New Query"),
                    react_1.default.createElement("div", { className: "grow" }),
                    react_1.default.createElement(iconButton_1.IconButton, { className: "sm mt-2", icon: react_1.default.createElement(outline_1.PlusCircleIcon, { className: "w-6 h-6 text-white" }), background: "bg-primary-500 hover:bg-primary-600", onClick: function () {
                            _this.setState({
                                query: defaultQueryInput,
                            }, function () {
                                _this.handleUpdateNewQueryModal(true);
                            });
                        } })),
                react_1.default.createElement(table_1.Table, { className: "py-7", header: this.filterTableHeader, data: this.renderFilterData(), loading: false }),
                react_1.default.createElement("div", { className: "mt-24 flex justify-end" },
                    react_1.default.createElement(button_1.Button, { text: "Slice", type: "normal", onClick: function () {
                            var _a, _b, _c;
                            (_b = (_a = _this.props).onChangeFilter) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = _this.state.queries) !== null && _c !== void 0 ? _c : []);
                            _this.props.onClose();
                        } }))));
        }
    };
    return FilterModal;
}(react_1.Component));
exports.FilterModal = FilterModal;
var TabModal = /** @class */ (function (_super) {
    __extends(TabModal, _super);
    function TabModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabRef = (0, react_1.createRef)();
        _this.modalTabRef = (0, react_1.createRef)();
        _this.tabNameRef = (0, react_1.createRef)();
        _this.tabTypeSelectionRef = (0, react_1.createRef)();
        _this.tabPreviewImageRef = (0, react_1.createRef)();
        _this.tabIframeRef = (0, react_1.createRef)();
        _this.state = {
            tabName: "",
            tabTypeSelection: "iframe",
            previewImageSelection: "",
            iframeLink: "",
        };
        _this.handleAddTab = function () {
            var _a;
            var newTab = {
                name: (_a = _this.state.tabName) !== null && _a !== void 0 ? _a : "",
                type: _this.props.type === "list" || _this.props.type === "read"
                    ? _this.props.type
                    : "list",
                viewType: _this.state.tabTypeSelection,
                viewImage: _this.state.previewImageSelection,
                src: _this.state.iframeLink,
            };
            var clonedTabs = JSON.parse(JSON.stringify(_this.props.tabs));
            clonedTabs.push(newTab);
            if (_this.props.onChangeTabs) {
                _this.props.onChangeTabs(clonedTabs);
            }
            _this.props.onClose();
        };
        _this.renderViewTabOptions = function () {
            var viewTabList = [];
            tabTableType.map(function (eachViewType) {
                viewTabList.push({
                    key: eachViewType.key,
                    label: eachViewType.label,
                });
                return null;
            });
            if (_this.props.type === "read")
                return [{ key: "iframe", label: "IFrame" }];
            return viewTabList;
        };
        return _this;
    }
    TabModal.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(form_1.Form, { className: "pb-32 grid grid-cols-1 gap-y-6", refList: [
                    this.modalTabRef,
                    this.tabNameRef,
                    this.tabTypeSelectionRef,
                    this.tabPreviewImageRef,
                    this.tabIframeRef,
                ], ref: this.tabRef, handleComplete: function () { return _this.handleAddTab(); } },
                react_1.default.createElement(textInput_1.TextInput, { id: "tabName", ref: this.tabNameRef, value: this.state.tabName, type: "text", label: "Name", placeholder: "eg. Title", onChange: function (e) {
                        _this.setState({ tabName: e.target.value });
                    } }),
                react_1.default.createElement(select_1.Select, { label: "View Type", ref: this.tabTypeSelectionRef, options: this.renderViewTabOptions(), value: (_a = this.state.tabTypeSelection) !== null && _a !== void 0 ? _a : "", onChange: function (value) {
                        _this.setState({ tabTypeSelection: value });
                    } }),
                (this.state.tabTypeSelection === "grid" ||
                    this.state.tabTypeSelection === "list") && (react_1.default.createElement(select_1.Select, { id: "tabPreviewImage", label: "Preview Image", ref: this.tabPreviewImageRef, options: (_d = (_c = (_b = this.props).renderReferenceLabelOptions) === null || _c === void 0 ? void 0 : _c.call(_b, "", false, "image")) !== null && _d !== void 0 ? _d : [], value: (_e = this.state.previewImageSelection) !== null && _e !== void 0 ? _e : "", onChange: function (value) {
                        _this.setState({ previewImageSelection: value });
                    } })),
                this.state.tabTypeSelection === "iframe" && (react_1.default.createElement(textInput_1.TextInput, { id: "tabIframe", ref: this.tabIframeRef, value: (_f = this.state.iframeLink) !== null && _f !== void 0 ? _f : "", type: "text", label: "Iframe Src", placeholder: "eg. https://link.com", onChange: function (e) {
                        _this.setState({ iframeLink: e.target.value });
                    } }))),
            react_1.default.createElement("div", { className: "flex justify-end item-end" },
                react_1.default.createElement(button_1.Button, { text: "Add Tab", type: "normal", onClick: function () { var _a; return (_a = _this.tabRef.current) === null || _a === void 0 ? void 0 : _a.handleSubmit(); } }))));
    };
    return TabModal;
}(react_1.Component));
exports.TabModal = TabModal;
//# sourceMappingURL=settingsModal.js.map